export const AAD_LOGIN_SUCCESS = "AAD_LOGIN_SUCCESS";
export const AAD_ACCOUNT_ADDED = "AAD_ACCOUNT_ADDED";
export const LOGIN = "auth/AAD_LOGIN";
export const ACQUIRED_TOKEN = "auth/ACQUIRED_TOKEN";
export const AAD_REDIRECT_END = "auth/AAD_REDIRECT_END";